import axios from "@/plugins/axios.js";
import helpersJs from "@/plugins/helpers.js";
import store from "../store";

export default {
  async initialiseCompanyAndLogo() {
    if (!store.getters.getAuthenticated) {
      return;
    }
    const userCompany = await this.getUserCompany();
    helpersJs.initialiseOrUpdateCompanyDataInStorage(null, userCompany);
    await this.getLogos(userCompany.company.emis);
    await this.getStamps(userCompany.company.emis);
    return userCompany;
  },

  //not done
  // async getCompaniesForSelectedCategory(selectedCategories){
  //   const userCompany = await axios.getData(
  //     "/auth/get-user-company",
  //     localStorage.getItem("token")
  //   );
  //   return userCompany;
  // },
  async getFilteredCompanies(params) {
    try {
      const response = await axios.postData("/get-filtered-companies", params);
      return response;
    } catch (error) {
      console.error("Error fetching companies:", error);
      return { status: "error", companies: [], total: 0 };
    }
  },

  async getCompanyBySlug(slug) {
    try {
      return await axios.postData("/get-company-slug", { slug });
    } catch (error) {
      console.error("Error fetching company:", error);
      return { status: "error", company: null, total: 0 };
    }
  },

  /**
   * Fetch cities dynamically for cascading province selections
   */
  async getCitiesForProvinces(provinces = []) {
    try {
      const response = await axios.postData("/get-provinces-filter-options", {
        params: { provinces },
      });
      return response.data.cities || [];
    } catch (error) {
      console.error("Error fetching cities:", error);
      return [];
    }
  },

  getCompanyIndustriesApi() {
    return axios.postData("/get-companies-industries", {}).then((res) => {
      return res;
    });
  },
  async getProvinces() {
    return await axios.postData("/get-companies-provinces", {});
  },
  async getCities() {
    return await axios.postData("/get-companies-cities", {});
  },
  async getUserCompany() {
    const userCompany = await axios.getData(
      "/auth/get-user-company",
      localStorage.getItem("token")
    );
    return userCompany;
  },

  async getCompanyWithDomain(domain) {
    const company = await axios.postData("/get-user-company-with-domain", {
      domain,
    });
    return company;
  },

  async getCompanyWithEmis(emis) {
    const company = await axios.postData("/get-company-with-domain", { emis });
    return company;
  },
  async getLogos(emis) {
    let logos = [];
    const images = await axios.postData("/get-logos-for-given-company", {
      folder: "logos",
      emis: emis,
    });

    if (images && images.length > 0) {
      logos = images;
      store.commit(
        "setLogo",
        store.getters.getApiUrl + "/images/logos/" + emis + "/" + images[0]
      );
    }

    return logos;
  },
  async getStamps(emis) {
    let stamps = [];
    const images = await axios.postData("/get-stamps-for-given-company", {
      folder: "stamps",
      emis: emis,
    });

    if (images && images.length > 0) {
      stamps = images;
      store.commit(
        "setStamp",
        store.getters.getApiUrl + "/images/stamps/" + emis + "/" + images[0]
      );
    }

    return stamps;
  },
  getCompanyIndustries() {
    return [
      "Legal Practice",
      "Private Practice",
      "Social Worker",
      "General Practice",
      "Construction",
      "Freelance",
      "Auto Services",
      "Auto Repairs",
      "Auto Mechanic",
      "General Services",
      "Event Planning",
      "Event Manager",
      "Project Manager",
      "Tender",
      "IT Support",
      "Home Services",
      "Consulting",
      "Logistics",
    ];
  },
  async getSiteInfo(emis, vue) {
    if (!emis) return null;

    store.commit("setLoader", true);

    try {
      const data = await axios.postData("/get-company-with-domain", { emis });

      vue.$emit("legal-services", data.legal_services);
      vue.$emit("get-company", data.company);

      store.commit("setCurrency", data.currency);
      store.commit("setUserCompany", data.company);
      store.commit("setCompanyLabels", data.labels);
      store.commit("setThemeColor", data.company.primary_bg_color);
      store.commit("setSecondaryColor", data.company.secondary_bg_color);
      store.commit("setAppName", data.company.name);

      // Save to localStorage
      localStorage.setItem("themeColor", data.company.primary_bg_color);
      localStorage.setItem("secondaryColor", data.company.secondary_bg_color);
      localStorage.setItem("appName", data.company.name);
      localStorage.setItem("userCompany", JSON.stringify(data.company));
      localStorage.setItem("companyLabels", JSON.stringify(data.labels));

      return data;
    } catch (error) {
      console.error("getSiteInfo error:", error);
      throw error;
    } finally {
      store.commit("setLoader", false);
    }
  },
  getMenuItems() {
    return [
      {
        icon: "mdi-web",
        title: "Front Page",
        route: "company-website",
        industry: ["All"],
        alevels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        icon: "mdi-apps",
        title: "Dashboard",
        route: "switchboard",
        industry: ["All"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        title: "Case Manager",
        icon: "mdi-file",
        route: "legal-case-manager",
        industry: ["Legal"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        title: "Clients",
        icon: "mdi-account-group",
        route: "manage-clients",
        industry: ["All"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        title: "Add / Edit Any Data",
        icon: "mdi-account-multiple",
        route: "data-crud",
        industry: ["All"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        title: "Billing & Invoices",
        icon: "mdi-file-document-edit",
        route: "invoices-and-quotes",
        industry: ["All"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        title: "POS / Sales",
        icon: "mdi-cash-register",
        route: "point-of-sale",
        industry: ["POS"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      // {
      //   title: "Schedule",
      //   icon: "mdi-calendar",
      //   route: "bulk-emails-dashboard",
      //   industry: ["General", "Legal Practice", "Agency"],
      // alevels:[7,8,9,10,11,12,13,14,15]
      // },
      {
        title: "Site Images",
        icon: "mdi-image",
        route: "website-dashboard",
        industry: ["All"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        title: "Staff & Payroll",
        icon: "mdi-account-tie",
        route: "manage-employees",
        industry: ["None"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        title: "Products & Services",
        icon: "mdi-package-variant",
        route: "manage-products",
        industry: ["General"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        title: "SMS & Email Marketing",
        icon: "mdi-email",
        route: "bulk-emails-dashboard",
        industry: ["None"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        title: "Manage Users",
        icon: "mdi-account-multiple",
        route: "manage-users",
        industry: ["All"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        title: "Company Profile",
        icon: "mdi-cog",
        route: "settings",
        industry: ["All"],
        alevels: [7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
    ];
  },
  getSampleCompany() {
    return {
      id: 1000001,
      emis: "",
      name: "Bits-Invoice",
      domain: "mahlanguattorneys.co.za",
      email: "info@mahlanguattorneys.co.za",
      date_created: "2026-07-15 14:21:48",
      industry: "Legal Services",
      package: "premium",
      description:
        "Boutique South African law firm specializing in corporate law, commercial litigation, and estate administration in KwaZulu-Natal.",
      primary_phone: "+27 76 243 9441",
      primary_address:
        "Suite 401, Kingsmead Office Park, 20 Masabalala Yengwa Avenue",
      city: "Durban",
      postal_code: "4001",
      bank: "First National Bank (FNB)",
      account_number: "62894451023",
      account_type: "Business Cheque Account",
      province: "KwaZulu-Natal",
      notes:
        "Main branch based in Durban. Retainer client accounts should be settled strictly on a 30-day basis. Handled by Lead Partner, Sipho Mahlangu.",
      stamp: "M&P_DBN_OFFICIAL_STAMP_2026.png",
      tax_rate: "15",
      map_source:
        '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3460.5!2d31.02!3d-29.85" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>',
      merchant_number: "MERCH-992384-ZA",
      merchant_key: "sec_key_live_58c2a93fb23910ff9d832d2c1c1a",
      currency: "R",
      vat_number: "4630280000",
      reg_number: "1991/012000/01",
    };
  },
};
